export default __webpack_public_path__ + "static/media/empty.127f1e7e.svg";